import { useRef, useState } from "react";
import { useUploadFile } from "@/api/AppApi/services/upload-file";
import {
  IUploadErr,
  TempFile,
  deepCopyFunction,
  fileNotAccepted,
} from "../upload-files-helpers/upload";
import { getIsImage } from "../HookUploadOneFile";

export const useUploadFiles = () => {
  const uniqueIdRef = useRef({ id: 0, fileList: [] });
  const [filesUrls, setFilesUrls] = useState<TempFile[]>([]);
  const [msgErr, setMsgErr] = useState<IUploadErr[]>([]);
  const uploadFile = useUploadFile({
    onSuccess: (res) => {
      let list = deepCopyFunction(uniqueIdRef.current.fileList);
      const index = list.findIndex((item: any) => !item.url);
      list[index].url = res.result.absolute_url ?? null;
      list[index].isImage = getIsImage(res.result?.absolute_url) ?? false;
      list[index].thumbnail = res.result?.thumbnail_absolute_url;
      setFilesUrls(deepCopyFunction(list));
      uniqueIdRef.current.fileList = deepCopyFunction(list);
    },
    onError: (err) => {
      if (err.response?.status === 422) {
        let list = deepCopyFunction(uniqueIdRef.current.fileList);
        const index = list.findIndex((item: any) => item.url === "");
        list.splice(index, 1);
        setFilesUrls(deepCopyFunction(list));
        uniqueIdRef.current.fileList = deepCopyFunction(list);
      } else {
        console.log(err);
      }
    },
  });
  const handleUpload = async (fileList: FileList | null) => {
    if (!fileList) return;
    const files = Array.from(fileList);
    let acceptedFiles = [];
    let illegalFiles = [];
    let currentList = deepCopyFunction(filesUrls);
    for (let i = 0; i < files.length; i++) {
      const illegalFile = fileNotAccepted(files[i]);
      if (illegalFile) {
        illegalFiles.push(illegalFile);
        continue;
      }
      acceptedFiles.push(files[i]);
      uniqueIdRef.current.id += 1;
      const newFile = {
        id: uniqueIdRef.current.id,
        name: files[i].name,
        url: null,
        isImage: false,
      };
      currentList.push({ ...newFile });
    }
    setMsgErr(illegalFiles);
    setFilesUrls(deepCopyFunction(currentList));
    uniqueIdRef.current.fileList = deepCopyFunction(currentList);
    for (let i = 0; i < acceptedFiles.length; i++) {
      try {
        await uploadFile.mutateAsync({ file: acceptedFiles[i] });
      } catch (err) {}
    }
  };
  const handleRemove = (index: number) => {
    const currentFiles = [...filesUrls];
    currentFiles.splice(index, 1);
    setFilesUrls(currentFiles);
  };
  return {
    filesUrls,
    setFilesUrls,
    msgErr,
    setMsgErr,
    handleUpload,
    handleRemove,
  };
};
